class FloatingCloser {
  constructor(el) {
    this.dom = {el: el};
    this.dom.trigger = this.dom.el;
    this.dom.target = document.querySelector('[data-js="floating-banner"]');

    this.hidden = this.hidden.bind(this);

    this.init();
  }

  init() {
    this.dom.trigger.addEventListener('click', this.hidden);
  }

  hidden() {
    this.dom.target.dataset.is = 'hidden';
    setTimeout(()=>{
      this.dom.target.remove();
    }, 1000)
  }
}

export default FloatingCloser